/*** FUNs ***/
export function parsePercent(value) {
    const cleanedValue = value?.replace('%', '');
    
    return cleanedValue ? parseFloat(cleanedValue) : undefined;
}

export function formatPercent(value) {
    // format value as percent, keep 2 decimal only
    const f = parsePercent(value);
    // parseFloat(value);

    if( isNaN(f) ) {
        return;
    }

    // Format the number to two decimal places and remove trailing zeros
    const f2 = f.toFixed(2).replace(/\.00$/, '').replace(/\.0$/, '')
    return `${f2}%`; 
}

/*** DJANGO  ***/
export function getCookie(name) {
    // GET DJANGO CSRF COOKIE
    // required to make a POST,...

    let cookieValue = null;

    if( document.cookie && document.cookie !== '' ) {
        const cookies = document.cookie.split(';');
        for( let i = 0; i < cookies.length; i++ ) {
            const cookie = cookies[i].trim();
            // Check if this cookie string begins with the desired name
            if( cookie.substring(0, name.length + 1) === (name + '=') ) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }

    return cookieValue;
}

/*** REACT ***/
export async function setImageConvert( file ,onUpload ) {
    const fileType = file.type;
    const nativeImageTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/svg', 'image/webp'];

    //! Check if the file is native (able to be drawn by browser)
    if( nativeImageTypes.includes(fileType) ) {
        const imageObjectURL = URL.createObjectURL(file); // Create a URL for the Blob
        const reader = new FileReader();

        reader.onloadend = () => {
            onUpload( file ,imageObjectURL ,String(reader.result) )
        };

        reader.readAsDataURL(file);

    //! Else call ImPaaS proxy to convert the image before setting it
    } else {
        const csrftoken = getCookie('csrftoken');
        const formData = new FormData();

        formData.append('file', file);

        const response = await fetch('/auth/proxy/convert?ext=png', {
            method: 'POST',
            headers: {
                'X-CSRFToken': csrftoken, // Add the CSRF token here
            },
            body: formData,
        });

        if( !response.ok ) {
            throw new Error('Failed to convert image');
        }

        const imageBlob = await response.blob(); // Get the image as a Blob
        const imageObjectURL = URL.createObjectURL(imageBlob); // Create a URL for the Blob

        onUpload( file ,imageObjectURL ,imageObjectURL );
    }
}